import Controller from './controller'

export default class extends Controller {
  initialize() {
    this.copy = this.copy.bind(this)
  }

  copy() {
    let url = this.element.getAttribute('data-value')

    navigator.clipboard.writeText(url).then(() => {
      this.element.classList.add('is-copied')
      setTimeout(() => {
        this.element.classList.remove('is-copied')
      }, 1500);
    }, () => {
      console.log('Copy error')
    });
  }
}
